/**
 * 门户边框默认配置数据
 */
export const home = [
  {
    dateStyle: "1",
    width: 230
  }
]

/**
 * 大屏边框默认配置数据
 */
export const bs = [
  {
    dateStyle: "4"
  }
]

/**
 * app日期默认配置数据
 */
export const appHome = [
  {
    dateStyle: "1",
    width: 230
  }
]
